import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "width"
    }}>{`width`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v4.1`}</p>
    <p>{`Enables you to restrict a set of CSS rules to match when the size of the plugin's dialog or panel meets your specified criteria.`}</p>
    <p><strong parentName="p">{`See:`}</strong>{` `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/@media/width"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/CSS/@media/width`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`@media (max-width: 700px) {
    .someElement {
        background-color: red;
    }
}
`}</code></pre>
    <h2 {...{
      "id": "known-issues"
    }}>{`Known Issues`}</h2>
    <ul>
      <li parentName="ul">{`When a plugin has multiple panels, only the size of the first panel is used for this calculation. As such, media queries based on viewport size do not make much sense when a plugin as two or more panels.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      